import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "mb-4 text-2xl font-bold text-gray-800 sm:mb-6 lg:mb-8 xl:text-3xl" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3" }

import { computed, ComputedRef } from 'vue';
import { UserModel, DashboardItem, Permission } from '@/types';
import {
    AnnotationIcon,
    BanIcon,
    BookOpenIcon,
    ClockIcon,
    CloudUploadIcon,
    LinkIcon,
    LockClosedIcon,
    MenuAlt2Icon,
    OfficeBuildingIcon,
    PhoneIcon,
    TagIcon,
    UserGroupIcon,
    UsersIcon,
} from '@heroicons/vue/solid';
import ConnectFlowIcon from '@/components/svg/ConnectFlowIcon';
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';
import { useAuthStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

const links: DashboardItem[] = [
    {
        title: 'dashboard.settings.levels',
        description: 'level.description',
        permission: Permission.VIEW_LEVELS,
        routeName: 'ListLevel',
        icon: OfficeBuildingIcon,
    },
    {
        title: 'dashboard.settings.users',
        description: 'user.description',
        permission: Permission.VIEW_USERS,
        routeName: 'ListUser',
        icon: UsersIcon,
    },
    {
        title: 'dashboard.settings.userLabel',
        description: 'userLabel.description',
        permission: Permission.VIEW_USER_LABELS,
        routeName: 'ListUserLabel',
        icon: UserGroupIcon,
    },
    {
        title: 'dashboard.settings.numbers',
        description: 'number.description',
        permission: Permission.VIEW_NUMBERS,
        routeName: 'ListNumber',
        icon: PhoneIcon,
    },
    {
        title: 'dashboard.settings.whatsappCodes',
        description: 'whatsappCode.description',
        permission: Permission.VIEW_WHATSAPP_CODES,
        routeName: 'ListWhatsappCodeNumbers',
        icon: SVGWhatsApp,
    },
    {
        title: 'dashboard.settings.contacts',
        description: 'contact.description',
        permission: Permission.VIEW_CONTACTS,
        routeName: 'ListContact',
        icon: BookOpenIcon,
    },
    {
        title: 'dashboard.settings.spamNumber',
        description: 'spamNumber.description',
        permission: Permission.VIEW_SPAM_NUMBERS,
        routeName: 'ListSpamNumber',
        icon: BanIcon,
    },
    {
        title: 'dashboard.settings.connectFlow',
        description: 'connectFlow.description',
        permission: Permission.VIEW_CONNECT_FLOWS,
        routeName: 'ListConnectFlow',
        icon: ConnectFlowIcon,
    },
    {
        title: 'dashboard.settings.connectFlowAudios',
        description: 'connectFlowAudio.description',
        permission: Permission.VIEW_CONNECT_FLOW_AUDIOS,
        routeName: 'ListConnectFlowAudio',
        icon: CloudUploadIcon,
    },
    {
        title: 'dashboard.settings.queues',
        description: 'queue.description',
        permission: Permission.VIEW_QUEUES,
        routeName: 'ListQueue',
        icon: MenuAlt2Icon,
    },
    {
        title: 'dashboard.settings.schedules',
        description: 'schedule.description',
        permission: Permission.VIEW_SCHEDULES,
        routeName: 'ListSchedule',
        icon: ClockIcon,
    },
    {
        title: 'dashboard.settings.surveys',
        description: 'connectFlowSurvey.description',
        permission: Permission.VIEW_CONNECT_FLOW_SURVEYS,
        routeName: 'ListConnectFlowSurvey',
        icon: AnnotationIcon,
    },
    {
        title: 'dashboard.settings.words',
        description: 'word.description',
        permission: Permission.VIEW_WORDS,
        routeName: 'ListWord',
        icon: TagIcon,
    },
    {
        title: 'dashboard.settings.integrations',
        description: 'integration.description',
        permission: Permission.VIEW_INTEGRATIONS,
        routeName: 'ListIntegration',
        icon: LinkIcon,
    },
    {
        title: 'dashboard.settings.roles',
        description: 'role.description',
        permission: Permission.ASSIGN_ROLE_TO_USER,
        routeName: 'Permissions',
        icon: LockClosedIcon,
    },
];

return (_ctx: any,_cache: any) => {
  const _component_UiDashboardLink = _resolveComponent("UiDashboardLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('welcomeLogged')) + ", " + _toDisplayString(user.value?.name) + ". ", 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, index) => {
        return _createVNode(_component_UiDashboardLink, {
          key: `dashboard-link-${index}`,
          routeName: link.routeName,
          permission: link.permission,
          title: link.title,
          description: link.description,
          icon: link.icon
        }, null, 8, ["routeName", "permission", "title", "description", "icon"])
      }), 64))
    ])
  ]))
}
}

})